import React from 'react';
import { Button, Tooltip } from 'antd';
import { CopyOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNotify } from 'react-admin';

/**
 * The log is the one piece of a change instance that is genuinely free text,
 * so it gets a console treatment: monospace on a dark surface, scrollable,
 * copyable. Shared by both POVs' detail panels.
 */
const ChangeLogPanel = ({ log }: { log?: string }) => {
    const notify = useNotify();
    const value = (log || '').trim();

    const copy = () => {
        navigator.clipboard?.writeText(value)
            .then(() => notify('Log copied to clipboard'))
            .catch(() => notify('Could not copy', 'error'));
    };

    return (
        <section className="ci-block">
            <header className="ci-block__head">
                <FileTextOutlined className="ci-block__icon" aria-hidden="true" />
                <h4 className="ci-block__title">Log</h4>
                {value && (
                    <Tooltip title="Copy log">
                        <Button
                            className="ci-block__action"
                            size="small"
                            icon={<CopyOutlined />}
                            onClick={copy}
                            aria-label="Copy log"
                        >
                            Copy
                        </Button>
                    </Tooltip>
                )}
            </header>
            {value ? (
                <pre className="ci-log">{value}</pre>
            ) : (
                <div className="ci-log ci-log--empty">No log recorded for this change.</div>
            )}
        </section>
    );
};

export default ChangeLogPanel;
